import React from "react";
import "./produklist.scss";
import datahome from "./datahome.json";
import Card from "../../../Component/Cardhome/cardhome";
import Terraviahomeimages from "../../../Media/homeimages/Terraviahome";
import Tanakayuhomeimages from "../../../Media/homeimages/Tanakayuhome";
import Hierahomeimages from "../../../Media/homeimages/Hierahome";
import Eonnahomeimages from "../../../Media/homeimages/Eonnahome";
import Blizfieldhomeimages from "../../../Media/homeimages/blizfieldhome";
import Caelushomeimages from "../../../Media/homeimages/Caelushome";
import Tresorhomeimages from "../../../Media/homeimages/Tresorhome";
import Enchantehomeimages from "../../../Media/homeimages/Enchantehome";
import Navaparkhomeimages from "../../../Media/homeimages/navaparkhome";
import Armonthomeimages from "../../../Media/homeimages/Armonthome";
import Vireyahomeimages from "../../../Media/homeimages/Vyorelle";
import Izzihomeimages from "../../../Media/homeimages/Izzihome";

const imageMap = {
  Terraviahomeimages,
  Tanakayuhomeimages,
  Hierahomeimages,
  Eonnahomeimages,
  Blizfieldhomeimages,
  Caelushomeimages,
  Tresorhomeimages,
  Enchantehomeimages,
  Navaparkhomeimages,
  Armonthomeimages,
  Vireyahomeimages,
  Izzihomeimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="residentials" className="produk">
      <h1>A place where you will call home</h1>
      <h2>Our Choice of home</h2>
      <div className="cardhome-containerhome">
        {datahome.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              pagelink={card.pagelink}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
